import Icon from '../components/Icon.vue'

Icon.register({
  'file-image': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 121.9v6.1h-128v-128h6.1c5.5 0 13.1 3.1 17 7l97.9 97.9c3.9 3.9 7 11.5 7 17zM248 160h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136c0 13.2 10.8 24 24 24zM112.5 176c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zM320.5 416v-112l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0l-103.5 103.5-39.5-39.5c-4.7-4.7-11.8-5.2-16.5-0.5l-39.5 39.5-0.5 48.5h256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-image.js
// module id = 1333
// module chunks = 0